module.exports = __webpack_public_path__ + "static/crowd2-f1328c2428760e0fd588b449d717b391.jpg";